<template>
  <v-layout>
    <app-loader
      title="Загрузка данных Планирования маршрутов"
      :loading="loading"
    />
    <v-layout
      v-show="!loading"
      column
    >
      <v-flex>
        <v-card class="mb-2 route-header">
          <v-card-text class="pa-1">
            <v-layout
              align-center
              wrap
            >
              <div style="width:40px">
                <RoutePlanningFilter @changeFilter="getData" />
              </div>
              <v-flex
                xs12
                sm11
                md7
              >
                <LocationSelect
                  class="mr-2"
                  @input="getData"
                />
              </v-flex>
              <v-layout column>
                <ShippingStateSelect @change="getData" />
                <DeliveryTypeSelect @change="getData" />
              </v-layout>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-layout class="mb-1 route-cards">
        <v-flex>
          <v-layout
            wrap
            align-end
            style="height:100%;"
          >
            <RouteCard
              v-for="route in planningRoutes"
              :key="route.routeId || route.draftId"
              :route="route"
              :is-in-route="true"
              :compact-mode="compactMode"
            />
            <v-btn
              small
              icon
              class="mr-0"
              @click="changeCompactMode"
            >
              <v-icon>
                {{ compactMode ? "fullscreen_exit" : "fullscreen" }}
              </v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout class="elevation-2">
        <v-flex xs12>
          <ShippingsByDirection
            :block-height="blockHeight"
            :compact-mode="compactMode"
          />
        </v-flex>
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
import LocationSelect from "./components/LocationSelect.vue";
import ShippingsByDirection from "./components/ShippingsByDirection.vue";
import RouteCard from "./components/RouteCard.vue";
import DeliveryTypeSelect from "./components/DeliveryTypeSelect.vue";
import ShippingStateSelect from "./components/ShippingStateSelect.vue";
import RoutePlanningFilter from "./components/RoutePlanningFilter.vue";

export default {
  components: {
    LocationSelect,
    ShippingsByDirection,
    RouteCard,
    DeliveryTypeSelect,
    ShippingStateSelect,
    RoutePlanningFilter,
  },
  data() {
    return {
      blockHeight: 0,
      loading: false,
    };
  },
  computed: {
    planningRoutes() {
      return this.$store.getters["routePlanning/planningRoutes"];
    },
    compactMode() {
      return this.$store.getters["routePlanning/compactMode"];
    },
  },
  updated() {
    this.$nextTick(function() {
      const elRoute = document.getElementsByClassName("route-cards");
      const elHeader = document.getElementsByClassName("route-header");
      const heightRoute = elRoute.length ? elRoute[0].offsetHeight : 0;
      const heightHeader = elHeader.length ? elHeader[0].offsetHeight : 0;
      this.blockHeight = window.innerHeight - heightHeader - heightRoute - 53;
    });
  },

  async created() {
    await this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      await this.$store.dispatch("routePlanning/getPlanningRoutes");
      await this.$store.dispatch("routePlanning/getPhasesRoutePlanning");
      this.loading = false;
    },
    changeCompactMode() {
      this.$store.commit("routePlanning/setCompactMode", !this.compactMode);
    },
  },
};
</script>
